module.exports = __webpack_public_path__ + "img/caiji-youshi-1-3.cf1ec414.png";